import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import CustomerResponseDetails from "../../models/Customer/CustomerResponseDetails";
import { trackEvent } from "../../appInsights/TelemetryService";
import { useSelector, useDispatch } from "react-redux"
import { saveCustomerphoneNumber, selectedTenacyType } from "../../ducks/redux/actions/getAddress";
import { MaintenanceResponsibilityEnum } from "../../models/Property/MaintenanceResponsibilityEnum";
import { getHeatingType } from "../../models/Property/heatingElements";
import { formatDateWithSlashFromCalendar, isNullOrUndefined, getAssetStatusDescriptionByStatus} from "../../utils/formatting";
import { backToCaseAsset, userChosentenancyGroup, woFailureCase } from "../../ducks/redux/actions/userChoices";
import { USERCHOSEN_PROPERTY_ID } from "../../ducks/redux/actionTypes";
import * as api from "../../api";
import { PremisesType } from "../../models/Customer/Premises";
import { PermissionsList } from "../../models/Permissions";
import HighRise from "../HighRise";
import houseIcon from "../../assets/icons/property.png";
import blockIcon from "../../assets/icons/my-block.png";
import estateIcon from "../../assets/icons/estate.png";
import { priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import '../../utils/commonCss/icons.css'
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getAssetsById, getAssociatedAssets, GetHighRiseProperty } from "../APIErrorComponent/APIConstantName";

interface AssetDetailCardProps extends RouteComponentProps<any> {
  customerAssetList?: CustomerResponseDetails[];
  errorFlag?: boolean;
}

const isPropertyWithEligibleStatus = (assetType: string | undefined, assetStatus: string | undefined) => {
  return assetType === "Property" && (assetStatus === "OCCP" || assetStatus === "VOID");
};

const isCommunalTenancy = (selectedTenacy: string | undefined) => {
  return selectedTenacy === "Divided Block" || selectedTenacy === "Block" || selectedTenacy === "Estate";
};

const getMaintenanceResponsibilityLabel = (maintenanceResponsibilityValue: string | undefined) => {
  if (
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.FMFULL ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.QLYES ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.DEFAULTED
  ) {
    return "Peabody";
  }

  if (maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.EMAFULL) {
    return "EMA";
  }

  if (
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.FMPART ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.SINGLE
  ) {
    return "PartiallyPeabody";
  }

  if (
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.QLNO ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.AGENT ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.OWNER ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.FREEHDFULL ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.FREEHOLD ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.LEASEHOLD ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.LEASEHDFULL ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.LEASHDFULL ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.LEASEHOLDR ||
    maintenanceResponsibilityValue === MaintenanceResponsibilityEnum.NONE
  ) {
    return "NotPeabody";
  }

  return "";
};

const getMaintenanceDetails = (maintenanceResponsibilities: any[] = []) => {
  const maintenanceResponsibilityValue = maintenanceResponsibilities.find(
    (a: { type: string; }) => a.type === "MAINTSRESP"
  )?.value;

  const heatingData = maintenanceResponsibilities.find(
    (a: { type: string; }) => a.type.startsWith("HEAT")
  );

  return {
    maintenanceLabel: getMaintenanceResponsibilityLabel(maintenanceResponsibilityValue),
    heating: heatingData ? getHeatingType(heatingData.type, heatingData.value) : "",
  };
};

const getTenancyGroupValue = async (customerResponse: any, assetDataResponse: any) => {
  let tenancyGroup = "ALL";
  if (!isNullOrUndefined(customerResponse) && assetDataResponse?.assetType === "Property") {
    const id = customerResponse["customer-identifier"];
    if (id !== undefined) {
      const tenancyResponse = await api.getTenancies(id);
      if (tenancyResponse !== undefined) {
        tenancyGroup = tenancyResponse[0].tenancyGroup;
      }
    }
  }
  return tenancyGroup;
};

const AsssetDetailCard: React.FC<AssetDetailCardProps> = (props) => {
  const { t } = useTranslation();
  const {errorFlag} = props;
  const dispatch = useDispatch();
  const [maintenanceResponsibility, setMaintenanceResponsibility] = useState('')
  const [heatingType, setHeatingType] = useState('')
  const [dropDown, setDropDown] = useState("none");
  const [showSMSBtn, setShowSMSBtn] = useState(false);
  const assetDataResponse = useSelector(
    (state: any) => state?.userChoicesReducer?.assetDataResponse
  );
  const userChosenNoUnit = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenNoUnit
  );
  const localAuthority = useSelector(
    (state: any) => state?.userChoicesReducer?.localAuthority
  );
  let assetStatus = useSelector(
    (state: any) => state?.userChoicesReducer?.assetDataStatus
  );
  let selectedTenacy = useSelector(
    (state: any) => state?.addresses?.selectedTenancy
  );
  const customerResponse = useSelector(
    (state: any) => state?.addresses?.saveCustomerDetails
  );
  const isActiveTenancy = useSelector(
    (state: any) => state?.userChoicesReducer?.isActiveTenancy
  );

  const eligibleSelectCustomer = useSelector(
    (state: any) => state?.caseCreationReducer?.eligibleSelectCustomer
  );
  const isCaseCheck = useSelector(
    (state: any) => state?.userChoicesReducer?.isCaseAllowed
  );

  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );

  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const currentAssetEligibilityDetails = useSelector(
      (state: any) => state?.addresses?.currentAssetEligibilityDetails
    );
  const tenancyTypeDescription = useSelector((state: any) => state?.userChoicesReducer?.userChosenTenancyTypeDescription);
  const [tenancyTenure, setTenancyTenure] = useState("-");
  const showservicerequestcard = (Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.view_case_summary_card));
  const createCaseStandard = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_case_standard);
  const showRepair = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_repair_standard);
  useEffect(() => {
    const showSMS = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_asset360_block_sms);
    setShowSMSBtn(showSMS);
  }, [getPermissionsData])

  useEffect(() => {
    (async () => {
      trackEvent("AssetDetailCard");
      if (!isNullOrUndefined(customerResponse) && assetDataResponse?.assetType === "Property") {
        const tenancySummary: any = customerResponse.tenanciesSummaries?.find(
          (eachSummary: any) =>
            eachSummary.tenancySummary.uprn === assetDataResponse?.uprn
        );
        setTenancyTenure(tenancySummary?.tenancySummary?.tenancyTenure);
      }
      if (assetDataResponse?.maintenanceResponsibilities?.length > 0) {
        const maintenanceData = getMaintenanceDetails(assetDataResponse?.maintenanceResponsibilities);
        if (maintenanceData.maintenanceLabel) {
          setMaintenanceResponsibility(t(maintenanceData.maintenanceLabel));
        }
        if (maintenanceData.heating) {
          setHeatingType(maintenanceData.heating);
        }
      }
    })();
  }, [assetDataResponse, localAuthority, customerResponse]);

  const dropDownFunction = () => {
    if (dropDown === "none")
      setDropDown("block");
    else
      setDropDown("none");
  }

  const callPageHandler = () => {
    if (!isP360Maintainence) {
      dispatch(selectedTenacyType(selectedTenacy));
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      if (isNullOrUndefined(customerResponse?.addresses?.telecomsAddresses)) {
        dispatch(saveCustomerphoneNumber(null));
      }
      else {
        dispatch(saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses));
      }
      props.history.push("/RepairAsset", { previousPathname: globalThis.location.pathname } );
    }
  };

  const callCaseHandler = async () => {
    backToCaseAsset(false);
    if (assetDataResponse?.assetType === "Property" && eligibleSelectCustomer === true) {
      dispatch({ type: USERCHOSEN_PROPERTY_ID, payload: assetDataResponse?.id });
      props.history.push("/SelectCustomer");
    } else {
      const tenancyGroup = await getTenancyGroupValue(customerResponse, assetDataResponse);
      const tenancyGroupValue = assetDataResponse?.assetType === "Property" ? tenancyGroup : "All";
      dispatch(userChosentenancyGroup(tenancyGroupValue));
      props.history.push("/CaseType");
    }
  }
  const handleEmail = () => {
    props.history.push("/composeEmail");
  }


  const sendSMSFuction = () => {
    props.history.push("/composeSMS");
  }

  const getAssetIcon = (assetType: any) => {
    let icon = houseIcon;
    if (assetType === "Property") icon = houseIcon;
    if (assetType === "Block") icon = blockIcon;
    if (assetType === "Divided Block") icon = blockIcon;
    if (assetType?.includes("Estate")) icon = estateIcon;
    return icon;
  };

  const isKebabMenuVisible = showRepair || showservicerequestcard;
  const isCurrentSelectionEligible =
    (isActiveTenancy && selectedTenacy === "Property") ||
    isPropertyWithEligibleStatus(assetDataResponse?.assetType, assetStatus) ||
    isCommunalTenancy(selectedTenacy);
  const canRaiseRepair =
    showRepair &&
    currentAssetEligibilityDetails?.isEligibleToRaiseARepair &&
    ((selectedTenacy === "Property" && isActiveTenancy) ||
      isCommunalTenancy(selectedTenacy) ||
      isPropertyWithEligibleStatus(assetDataResponse?.assetType, assetStatus));

  return (
    <div className="relative pb-16 border border-grey bg-grey rounded-lg cust-card">
      {
        <div>
          <div className="px-4 py-2  bg-teal rounded-t-lg">
            <div className="flex flex-row d-flex bd-highlight items-center">
              <img src={getAssetIcon(assetDataResponse?.assetType)} className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="icon" />
              <h2 className="my-0 text-white bd-highlight">{assetDataResponse?.assetType}</h2>
              {isKebabMenuVisible && isCurrentSelectionEligible
                ?(
                  <div className="menu-nav ms-auto bd-highlight">
                    <div className="dropdown-container">
                      <div className="three-dots kebabMenu" data-testid="dots_menu" onClick={dropDownFunction}></div>
                      <div className="dropdown dropdown-margin" style={{ display: dropDown }}>
                      <div className="asset-detail-btn-col px-2 py-2">
                        {canRaiseRepair ? <button type={undefined}  data-testid="raise_rep" className="asset-detail-btn-col text-dark cursor-pointer global-txt no-underline" onClick={callPageHandler} onKeyDown={callPageHandler}><div className={"cursor-pointer no-underline dropdown-item py-2" + (isP360Maintainence ? ' text-opacity-25 pe-none' : '')}>{selectedTenacy === "Property" ? t("Create_repair") : t("raise_comm")}</div></button> : null}
                        {isCaseCheck === 'true' && createCaseStandard ? <button type={undefined} data-testid="casepage" className="asset-detail-btn-col text-dark cursor-pointer global-txt no-underline" onClick={callCaseHandler} onKeyDown={callCaseHandler}><div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item">{t("CP104")}</div></button> : null}
                      </div>
                      {selectedTenacy === "Block" && showSMSBtn &&
                          (<div className="asset-detail-btn-col">
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <button type={undefined} data-testid="Email" className="asset-detail-btn-col text-dark cursor-pointer global-txt no-underline" onClick={handleEmail} onKeyDown={handleEmail}><div className="cursor-pointer no-underline dropdown-item">{t("send_Email")}</div></button>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                           <button type={undefined} data-testid="SMS" className="asset-detail-btn-col text-dark cursor-pointer global-txt no-underline" onClick={sendSMSFuction}><div className="cursor-pointer no-underline dropdown-item">{t("send_SMS")}</div></button>
                          </div>)
                        }
                      </div>
                    </div>
                </div>
              ) : null}
            </div>
          </div>
             
              <div className="px-4 py-2 grid grid-cols-1 md:grid-cols-2">
                <><div className="py-2">
                    <div className="pr-4"><b>{t("asset_uprn")}</b></div>
                    <div>  {assetDataResponse?.uprn || "-"}</div>
                </div>
                <div className="py-2">
                     <div className="pr-4 ">
                  <div className="pr-4"><b>{t("asset_status")}</b>
                  </div>
                  <div>  {getAssetStatusDescriptionByStatus(assetDataResponse?.assetStatus,assetDataResponse?.assetType)}</div>
                </div> 
                 </div>
                 {assetDataResponse?.assetType === "Property" && <> <div className="py-2">
                  <div className="pr-4" data-testid="tenancyType"><b>{t("tenancy_type")}</b>
                  </div>
                  <div className="text-capitalize">{isNullOrUndefined(tenancyTypeDescription) ? "-" : tenancyTypeDescription}</div>
                </div>
                  <div className="py-2 ">
                    <div className="pr-4" data-testid="tenancyTenure"><b>{t("tenancy_tenure")}</b>
                    </div>
                    <div> {tenancyTenure || "-"} </div>
                  </div>
                  </>}
                  <div className="py-2">
                     <div className="pr-4"><b>{t("local_authority")}</b>
                  </div>
                  <div>  {isNullOrUndefined(localAuthority) ? "-" : localAuthority}</div>
                  </div>
                 
                </>
              
                 {assetDataResponse?.assetType === PremisesType.Block ?<div className="py-2">
                     
                    <div className="pr-4"><b>{t("No_of_units")}</b>
                    <div>{userChosenNoUnit || "-"}</div>
                    </div>
                    
                 </div>: null}
                 
                  <div className="py-2">
                      <div className="pr-4"><b>{t("Asbestos_status")}</b>
                  </div>
                  <div>  {isNullOrUndefined(assetDataResponse?.asbestosStatus) ? "-" : assetDataResponse?.asbestosStatus}</div>
                  </div>  
                                  <div className="py-2">
                  <div className="pr-4"><b>{t("maintenance_responsibility")}</b>
                  </div>
                  <div>  {maintenanceResponsibility || "-"}</div>
                </div>
                  
                  <div className="py-2">
                    <div className="pr-4"><b>{t("heating_type")}</b>
                  </div>
                  <div>  {heatingType || "-"}</div>
                  </div>
                  <div className="py-2">
                     <div><b>{t("Last_stock_condition_survey")}</b>
                  </div>
                  <div>  {isNullOrUndefined(assetDataResponse?.lastStockConditionSurveyDate) ? "-" : formatDateWithSlashFromCalendar(assetDataResponse?.lastStockConditionSurveyDate)}</div>
                  </div>
              </div>
               {(assetDataResponse?.assetType === "Property" || assetDataResponse?.assetType === "Block") && !errorFlag &&
                 <div className="px-4 border-t border-grey"> <HighRise {...props} /></div>}
                 <ErrorComponent input={[getAssociatedAssets, getAssetsById, GetHighRiseProperty]} />
              
             
        </div>}
    </div>
  )
};
export default AsssetDetailCard;